(() => {
  const banner = document.querySelector('[data-cookie-consent]');

  if (!banner) return;

  const acceptButton = banner.querySelector('[data-cookie-accept]');
  const declineButton = banner.querySelector('[data-cookie-decline]');
  const preferenceButtons = document.querySelectorAll('[data-cookie-settings]');
  const storageKey = 'ep-cookie-consent';
  const choiceTimestampKey = 'ep-cookie-consent-updated-at';
  const consentChangedEvent = 'ep:cookie-consent-changed';

  const getStoredChoice = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  };

  const storeChoice = (choice, capturedAt) => {
    try {
      window.localStorage.setItem(storageKey, choice);
      window.localStorage.setItem(choiceTimestampKey, capturedAt);
    } catch (error) {
      // The Shopify consent API remains the source of truth when storage is unavailable.
    }
  };

  const showBanner = focusChoice => {
    banner.hidden = false;
    banner.setAttribute('aria-hidden', 'false');

    if (focusChoice) acceptButton.focus();
  };

  const hideBanner = () => {
    banner.hidden = true;
    banner.setAttribute('aria-hidden', 'true');
  };

  const completeChoice = consent => {
    const choice = consent ? 'accepted' : 'essential-only';
    const capturedAt = new Date().toISOString();
    const finish = () => {
      storeChoice(choice, capturedAt);
      hideBanner();
      window.dispatchEvent(new CustomEvent(consentChangedEvent, {
        detail: { analytics: consent, capturedAt },
      }));
    };

    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: consent,
          marketing: consent,
          preferences: consent,
        },
        finish
      );
      return;
    }

    finish();
  };

  const shouldShowBanner = () => {
    if (getStoredChoice()) return false;

    const privacy = window.Shopify?.customerPrivacy;

    if (!privacy?.currentVisitorConsent) return true;

    const currentConsent = privacy.currentVisitorConsent();
    const hasShopifyDecision = Object.values(currentConsent).some(value => value === 'yes' || value === 'no');

    return privacy.shouldShowBanner() || !hasShopifyDecision;
  };

  const initialize = () => {
    if (shouldShowBanner()) showBanner(false);
  };

  acceptButton.addEventListener('click', () => completeChoice(true));
  declineButton.addEventListener('click', () => completeChoice(false));
  preferenceButtons.forEach(button => {
    button.addEventListener('click', () => showBanner(true));
  });

  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
      initialize();
    });
  } else {
    initialize();
  }
})();
